export const QM_LIST_ROLES = ['QM_LIST_OWN_ONLY', 'QM_LIST_READ_ALL', 'QM_LIST_EDIT_ALL'] as const;

export type QmListRoleValue = (typeof QM_LIST_ROLES)[number];

export const DEFAULT_QM_LIST_ROLE: QmListRoleValue = 'QM_LIST_OWN_ONLY';

export function isQmListRoleValue(role: string | null | undefined): role is QmListRoleValue {
  return role === 'QM_LIST_OWN_ONLY' || role === 'QM_LIST_READ_ALL' || role === 'QM_LIST_EDIT_ALL';
}

export function toQmListRoleOrNull(role: string | null | undefined): QmListRoleValue | null {
  return isQmListRoleValue(role) ? role : null;
}

export function toQmListRoleValue(role: string | null | undefined): QmListRoleValue {
  if (isQmListRoleValue(role)) return role;

  return DEFAULT_QM_LIST_ROLE;
}

export function getQmListRoleLabel(role: string | null | undefined): string {
  const normalizedRole = toQmListRoleValue(role);

  if (normalizedRole === 'QM_LIST_EDIT_ALL') return 'Create/view/edit all QMs';
  if (normalizedRole === 'QM_LIST_READ_ALL') return 'Create/view/edit own QMs + view all other QMs';

  return 'Create/view/edit own QMs';
}

export function getQmListRoleShortLabel(role: string | null | undefined): string {
  const normalizedRole = toQmListRoleValue(role);

  if (normalizedRole === 'QM_LIST_EDIT_ALL') return 'Write All';
  if (normalizedRole === 'QM_LIST_READ_ALL') return 'Read All';

  return 'Own Only';
}
